import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { analyticsConfigured, getConsent, trackPageView } from "../lib/analytics";

// Envía un mf_page_view al dataLayer en cada cambio de ruta de la SPA.
// GTM lo convierte en el page_view de GA4. Solo tras consentimiento y
// solo en el dominio de producción (lo garantiza lib/analytics).
export const AnalyticsPageViews = () => {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    if (!analyticsConfigured || getConsent()?.analytics !== true) return;
    const path = `${location.pathname}${location.search}${location.hash}`;
    if (lastPath.current === path) return;
    lastPath.current = path;
    trackPageView();
  }, [location]);

  return null;
};
